module.exports = __webpack_public_path__ + "pf.cd4ca0aae8ee2e05c77c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pf.svg
// module chunks = styles